module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-26.47e79626.png";